import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import MarginPositionsPage from './MarginPositionsPage';
import MarginTriggersPage from './MarginTriggersPage';
import MarginApyPage from './MarginApyPage';
import MarginCoursePage from './MarginCoursePage';
import MarginCreditorsPage from './MarginCreditorsPage';

const MarginPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Маржинальная торговля
      </Typography>

      <Routes>
        <Route path="/" element={<Navigate to="/margin/positions" replace />} />
        <Route path="/positions" element={<MarginPositionsPage />} />
        <Route path="/triggers" element={<MarginTriggersPage />} />
        <Route path="/apy" element={<MarginApyPage />} />
        <Route path="/course" element={<MarginCoursePage />} />
        <Route path="/creditors" element={<MarginCreditorsPage />} />
      </Routes>
    </Box>
  );
};

export default MarginPage;
